import { FormEvent, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import removeAllErrorMsg from "../../components/funcRemoveAllErros";
import { ApiEndpoints, reqPostDownloadFile } from "../../config/apiClient";

interface iProps {
    show: boolean
    handleClose: any,
    filtro: any,
}

export default function QrCodeModalDownloadRegistros ({show, handleClose, filtro}:iProps) {
    const [loading, setLoading] = useState<boolean>(false)

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dadosDownload = {
            data_inicial: filtro.data_inicial,
            data_final: filtro.data_final,
            id_empresa: filtro.id_empresa.length === 0 ? '0' : filtro.id_empresa,
            id_centro_custo: filtro.id_centro_custo,
            id_colaboradores: filtro.id_colaborador,
            formato: form.formato.value,
        }
        console.log(dadosDownload)

        if (!formValidado) {
            return
        }

        handleDownload(dadosDownload)
    }

    async function handleDownload(dados:any) {

        setLoading(true)

        let nome = `Registros-Ronda-${dados.data_inicial}-${dados.data_final}`
        let extensao = "pdf"
        if (dados.formato === "excel") {
            extensao = "xlsx"
        }
        let arquivo = `${nome}.${extensao}`
        
        await reqPostDownloadFile(ApiEndpoints.qrcodeDownloadRegistros, dados, arquivo)
        setLoading(false)

    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Download Relatório de Registros RONDA</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formDownloadRegistrosRonda`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Formato de Dados:</Form.Label>
                                <Form.Select name="formato" id="formato" aria-label="Selecione o Formato">
                                    <option value="excel">Excel</option>
                                    <option value="pdf">PDF</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br/>
                    <Button type="submit" disabled={loading}>{loading ? "Aguarde..." : "Download"}</Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}